import { Suspense, type SuspenseProps, useEffect, useState } from 'react'

/**
 * 클라이언트에서만 Suspense를 활성화하는 래퍼.
 * SSR 시에는 fallback을 렌더하고, 하이드레이션 후 Suspense children을 마운트한다.
 */
export function NoSsrSuspense({ children, fallback, ...rest }: SuspenseProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <>{fallback}</>
  }

  return (
    <Suspense fallback={fallback} {...rest}>
      {children}
    </Suspense>
  )
}
